var map = {
	"./id.svg": "./public/images/flags/id.svg",
	"./my.svg": "./public/images/flags/my.svg",
	"./ph.svg": "./public/images/flags/ph.svg",
	"./sg.svg": "./public/images/flags/sg.svg",
	"./th.svg": "./public/images/flags/th.svg",
	"./vn.svg": "./public/images/flags/vn.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/images/flags sync recursive ^\\.\\/.*\\.svg$";